import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import Aux from '../../hoc/Auxiliare';
import parse from 'html-react-parser';
import GLOBAL_CONFIG from '../../config/config';
import appGoogleTracking from '../../modules/googletracking';
import { mainLoaderToggle } from '../../modules/helpers';
import TitleContent from '../../components/Content/TitleContent/TitleContent';
import ReCaptcha from 'react-google-invisible-recaptcha';
import {
    dateConfig,
} from "../../modules/helpers";
import _LOCAL_CAPTCHA from '../../Models/Captcha';
import CampaignServices from '../../Services/Campaign';
import ValidateForm from '../../modules/validate';
class PrizeAlle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            minDate: dateConfig({
                promotion: window.PROMOTION_CAMPAIGN, //Minimum Purchase date
                status: "min",
                ...GLOBAL_CONFIG.Date,
            }),
            // maxDate: this.getMaxDate(),
            // ReceiptSum: this.DefaultSum,
            IsAdventCalendar: false,
            // genericErrorMessage: "",
            CodeIsValid: true,
            // MoreTerms: false,
            // loaderSubmit: false,
            // loaderError: false,
            // loaderGeneralError: false,
            promotionCampaign: window.PROMOTION_CAMPAIGN,
            isMobile: false,
            // IsProductAmountInvalid: false,
            // prizeAvailableError: "",
            // showPopup: false,
            errorcode:false,
            errorfullname:false,
            erroriban:false,
            errorPurchase:false,
            errorFile:false,
            showPopup: false,
            errorCodePopup: null,

            // errorFile:false,
        };
        this.DisplayRecieptForm = this.DisplayRecieptForm.bind(this);
        this.capitalizeFirstLetter = this.capitalizeFirstLetter.bind(this);
        this.TriggerCaptcha = this.TriggerCaptcha.bind(this);
        this.validationBlur = this.validationBlur.bind(this);
        this.handleFile = this.handleFile.bind(this);
        this.googleTag = this.googleTag.bind(this);
        window.addEventListener("resize", this.resize);
        this.resize();
    }
    // huhu validation on blur form
    validationBlur(e, stateProperty,regex){
        if (!e.target.value.match(regex) || !e.target.value){
           this.setState({ [stateProperty]: true });
            e.target.classList.remove("valid");
            e.target.classList.add("notvalid");
        //    alert('ato')
        }
        else{
            this.setState({ [stateProperty]: false });
            e.target.classList.remove("notvalid");
            e.target.classList.add("valid");
        }
        
    }
    //huhu_validation size 
    handleFile = (e) => {
        const file = e.target.files[0];
        const maxSizeInBytes = 10 * 1024 * 1024; // 3 Mo
        const allowedExtensions = ['jpg', 'jpeg', 'pdf'];
        const fileName = file.name.toLowerCase();
        const fileExtension = fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2);

        const fileConditionParagraph = document.getElementById('fileCondition');

        if (!allowedExtensions.includes(fileExtension)) {
            console.log('Erreur : Type de fichier non pris en charge. Veuillez sélectionner un fichier JPG, JPEG ou PNG.');
            fileConditionParagraph.style.color = '#D93333';
            return;
        }
        if (file.size > maxSizeInBytes) {
            console.log('Erreur : La taille du fichier est trop grande.');
            fileConditionParagraph.style.color = '#D93333';
            return;
        }
        else {
            fileConditionParagraph.style.color = '#3b2774';
            this.setState({ errorFile: false });
            this.googleTag('choose_file', 'Winner Page', 'Click on Choose A File', 'EASTER_WP_PART')
        }
    }
    resize() {
        // set isMobile to true if the device is a mobile and false otherwise
        this.setState({ isMobile: window.innerWidth <= 768 });
    }
    componentDidMount() {
      

        ValidateForm.validateField('frm_receipt');    //parameter : form id

        mainLoaderToggle('hide');

        //         const elementSelector = document.querySelectorAll('.content-faq p a'),
        //     elementSelectorLength = elementSelector.length;

        // for(let i=0; i < elementSelectorLength; i++){
        //     elementSelector[i].addEventListener('click', function(event){
        //         appGoogleTracking.dataLayerPush({
        //             'dataEvent': 	'info-click',
        //             'dataCategory': 'Informational Action',
        //             'dataAction': 	'Links',
        //             'dataLabel': 	t('Meta.title')
        //         });
        //     });
        // }

        //Virtual page
        // appGoogleTracking.dataLayerPush({
        //     'customEvent': {
        //         'event': 'virtual-page',
        //         'virtualUri': GLOBAL_CONFIG.Route.prize,
        //         'pageTitle': t('Meta.title')
        //     }
        // });
    }
    googleTag = (event, category, action, label) => {
        appGoogleTracking.dataLayerPush({
            'dataEvent': event,
            'dataCategory': category,
            'dataAction': action,
            'dataLabel': label
        })
    }
    componentWillUnmount() {
        //Show mainloader
        mainLoaderToggle('show');
    }

    onClosePopupHandler = () => {
        this.setState({
            showPopup: false,
        });
    };

    render() {

        const { t } = this.props;


        return (
            <Aux>
                {
                    this.state.loaderSubmit ?
                        <div className="simple-loader__container active">
                            <div className="simple-loader__indicator"></div>
                        </div>
                        : null
                }
                {this.state.showPopup ?
                    <div className="content-home content-participation">
                        <div className="js-overlay overlay overlay--black">
                            <div className="overlay__container overlay__content">
                                <div
                                    className="overlay__close"
                                    onClick={this.onClosePopupHandler}
                                ></div>
                                <p id="js-error-msg">{this.state.errorCodePopup}</p>
                            </div>
                        </div>
                    </div>
                    : null}
                <div className={`content-prize content-prize__${window.PROMOTION_CAMPAIGN}`} style={{ marginTop: "50px" }}>
                    <TitleContent
                        heading={parse(t('Page.Prize.title'))}
                        subheading={typeof t('Page.Prize.subtitle') === "string" ? parse(t('Page.Prize.subtitle')) : null}
                    />
                    <form
                        id="frm_receipt"
                        name="frm_receipt"
                        method="post"
                        action="/"
                        onSubmit={this.onSubmitHandler.bind(this)} noValidate>
                        {this.DisplayRecieptForm(t)}
                  
                    </form>
                </div>
            </Aux>
        );
    }
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    //Trigger the captcha
    TriggerCaptcha() {
        //Process captcha - after which form ajax will be handle
        if (this._CAPTCHA.getResponse() !== '') {
            this._CAPTCHA.reset();
        } else {
            this._CAPTCHA.execute();
        }
    }

    //When captcha is good -> Callback when Google capture is good
    onResolved = (token) => {
        //Process form
        // console.log('JIJIji',token);
        this.ProcessFormData(token);
    }

    DisplayRecieptForm(t) {
        let _captcha = _LOCAL_CAPTCHA[this.state.promotionCampaign];
//         const messageFileRequired = `Du hast noch keinen Kaufbeleg hochgeladen. Wähle die entsprechende Datei aus
// und lade deinen Kaufbeleg hoch. Bitte denke dabei daran, die nicht an der Aktion
// teilnehmenden Artikel auf dem Kaufbeleg unkenntlich zu machen.`;
      
        return (
            <div className="campaign-form-receipt">
                <div className="form-container centered">
                    <ReCaptcha
                        ref={ref => this._CAPTCHA = ref}
                        locale={_captcha.lang}
                        sitekey={_captcha.key}
                        onResolved={this.onResolved}
                    />
                </div>
                <div className="form-input__container ">
                    {/* <label className="form-input__label on-top" htmlFor={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Country.Id}>{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Country.Label} </label> */}
                    <label className="form-input__label on-top" style={{marginTop: '-7px', marginLeft: '-21px'}}>* Pflichtfelder</label>
                    <input className="form-input__input js-event-type-in js-event-ab"
                        type={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Type}
                        name={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}
                        id='huhuaaaaaaaaaaaaaaaaaaaaaaaaaaaa'
                        // placeholder={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Label}
                        // placeholder={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Label}
                        data-require="true"
                        placeholder='Gewinncode*'
                        // data-require={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Required}
                        data-type="text"
                        data-error-target={`#error-${t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}`}
                        // data-regex-pattern=""
                        data-required-message=""
                        data-pattern-message="Ups, da hat sich wohl ein Fehler in deinen Gewinncode eingeschlichen. Bitte überprüfe deinen Gewinncode."
                        data-event-fieldname="Gewinncode*"
                        data-event="form-click"
                        data-category="Form Action"
                        data-action="Gewinncode*"
                        data-label="Type In"
                        ref={input => this._DETAILS_code = input}

                        onBlur={(e)=>this.validationBlur(
                            e,
                            'errorcode',
                            '',
                        )}
                    />
                    {
                        this.state.errorcode ? <span className="form-input__error active">Ups, da hat sich wohl ein Fehler in deinen Gewinncode eingeschlichen. Bitte überprüfe deinen Gewinncode.</span>:null
                    }
                    <p className='text center font'> Gib deinen Gewinncode ein.</p>
                    {/* <span id={`error-${t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}`} className="form-input__error active"></span> */}
                </div>

                <h3>{t("Page.Prize.Form.title")}</h3>
                <img
                    src="/resources/images/upload-receipt-imgage.png"
                    width="156"
                    height="173"
                    alt="upload receipt"
                />
                <label className="btn__container btn--primary btn--hover custom-file-btn" htmlFor="file_to_upload">
                    <span className="desktop-only">
                        {window.PROMOTION_CAMPAIGN === "kaufland" ?
                            (this.state.isMobile ? t("Page.Prize.Form.Sections.Receipt.CTA", { returnObjects: true, }).mobile : t("Page.Prize.Form.Sections.Receipt.CTA", { returnObjects: true, }).desktop)
                            :
                            (t("Page.Prize.Form.Receipt", { returnObjects: true, }))
                        }
                    </span>
                    
                    <input
                        style={{display:'none'}}
                        ref={(fileInput) => (this._RECEIPT_file = fileInput)}
                        type="file"
                        id="file_to_upload"
                        name="file_to_upload"
                        data-require="true"
                        // data-file-required={
                        //     window.PROMOTION_CAMPAIGN === "rewe" && this.state.IsAdventCalendar ? "false" : "true"
                        // }
                        data-type="file"
                        data-error-target="#error-file"
                        // data-pattern-message={messageFileRequired}
                        // data-required-message={messageFileRequired}
                        data-oversize-error="Ungültige Dateigröße. Bitte beachten Sie, dass die erforderliche Dateigröße weniger als 10 MB beträgt."
                        data-format-error="Ungültiges Dateiformat. Bitte nur gültiges Format hochladen."
                        onChange={this.handleFile}
                        // onBlur={(e) => this.validationBlur(
                        //     e,
                        //     'errorFile',
                        //     ' ',
                        // )}
                    />
                </label>
                    {
                    this.state.errorFile ?
                    <div className='form-input__container'>
                        <span className="form-input__error active">Du hast noch keinen Kaufbeleg hochgeladen. Wähle die entsprechende Datei aus
                            und lade deinen Kaufbeleg hoch. Bitte denke dabei daran, die nicht an der Aktion
                            teilnehmenden Artikel auf dem Kaufbeleg unkenntlich zu machen.
                        </span>
                    </div> 
                     : null
                    }
                <div className="form-container results">
                    <span className="form-input__error js-file-error">Error</span>
                    <span className="form-input__success js-file-success">Success</span>
                </div>
                <p id='fileCondition' className='text center font  '> Du kannst deinen Kaufbeleg als .jpg oder .pdf hochladen.</p>
             
                <div className="form-input__container">
                    <input className="form-input__input js-event-type-in js-event-ab"
                        type={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Type}
                        name={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}
                        id='KaufpreisMilkaNascher-Ei'
                        data-require="true"
                        // placeholder={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Label}
                        placeholder='Kaufpreis Milka Nascher-Ei*'
                        // data-require={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Required}
                        // data-type="regex"
                        data-error-target={`#error-${t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}`}
                        data-regex-pattern="^1$"
                        // data-regex-pattern="^[1-9]\d*((\.|\,)\d+)?$"
                        data-required-message=""
                        data-pattern-message="Der akzeptable Eingangsbetrag sollte nur zwischen 5 und 200 Euro liegen."
                        data-event-fieldname="KaufpreisMilkaNascher-Ei*"
                        data-event="form-click" 
                        data-category="Form Action"
                        data-action="KaufpreisMilkaNascher-Ei*"
                        data-label="Type In"
                        ref={input => this._DETAILS_purchaseAmount = input}
                        onBlur={(e) => {
                           if(!e.target.value){
                               e.target.classList.remove("valid");
                               e.target.classList.add("notvalid");
                           }
                           else{
                               e.target.classList.remove("notvalid");
                               e.target.classList.add("valid");
                           }

                            let regex = /^[1-9]\d*((\.|\,)\d+)?$/;

                            if (!regex.test(e.target.value)) {
                                // La valeur ne correspond pas à la regex, donc elle n'est pas valide
                                e.target.classList.remove("valid");
                                e.target.classList.add("notvalid");
                            } else {
                                // La valeur correspond à la regex, donc elle est valide
                                e.target.classList.remove("notvalid");
                                e.target.classList.add("valid");
                            }
                        }} 
                        onChange={(e) => {
                            let regex = /^[1-9]\d*((\.|\,)\d+)?$/;

                            if (!regex.test(e.target.value)) {
                                // La valeur ne correspond pas à la regex, donc elle n'est pas valide
                                e.target.classList.remove("valid");
                                e.target.classList.add("notvalid");
                            } else {
                                // La valeur correspond à la regex, donc elle est valide
                                e.target.classList.remove("notvalid");
                                e.target.classList.add("valid");
                            }
                        }}
                    />
                   
                    <p className='text font center'>Gib den Kaufpreis in € ein, den du für das Milka Nascher-Ei bezahlt hast.</p>
                   
                    <input className="form-input__input js-event-type-in js-event-ab"
                        type={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Type}
                        name={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}
                        id='Vollständiger Name'
                        // placeholder={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Label}
                        placeholder='Vollständiger Name'
                        // data-require={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Required}
                        data-require="true"
                        data-type="text"
                        data-error-target={`#error-${t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}`}
                        // data-regex-pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,17}$"
                        data-required-message=""
                        data-pattern-message="Ups, da hat sich wohl ein Fehler in die E-Mail-Adresse eingeschlichen. Bitte überprüfe deine E-Mail."
                        data-event-fieldname="Max Mustermann"
                        data-event="form-click"
                        data-category="Form Action"
                        data-action="Max Mustermann"
                        data-label="Type In"
                        ref={input => this._DETAILS_fullname = input}
                        style={{marginBottom:'20px'}}
                        onBlur={(e)=>{
                            if(! e.target.value){
                                e.target.classList.remove("valid");
                                e.target.classList.add("notvalid");
                            }
                            else{
                                e.target.classList.remove("notvalid");
                                e.target.classList.add("valid");
                            }
                        }
                        }
                    />
                    {/* {
                        this.state.errorcode ? <span className="form-input__error active">Ups, da hat sich wohl ein Fehler in deinen Gewinncode eingeschlichen. Bitte überprüfe deinen Gewinncode.</span> : null
                    } */}
                    {/* <span id={`error-${t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}`} className="form-input__error active"></span> */}
                    <input className="form-input__input js-event-type-in js-event-ab"
                        type={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Type}
                        name={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}
                        id='iban'
                        data-require="true"
                        // placeholder={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Label}
                        placeholder='IBAN*'
                        // data-require={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Required}
                        data-type="text"
                        data-error-target={`#error-${t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}`}
                        // data-regex-pattern="^DE\d{20}$"
                        data-required-message=""
                        data-pattern-message="Ups, da hat sich wohl ein Fehler bei deiner IBAN eingeschlichen. Bitte überprüfe deine IBAN."
                        data-event-fieldname="IBAN"
                        data-event="form-click"
                        data-category="Form Action"
                        data-action="Email"
                        data-label="Type In"
                        ref={(input) => (this._DETAILS_iban = input)}
                        onBlur={(e) => this.validationBlur(
                            e,
                            'erroriban',
                            "^DE\\d{20}$"
                        )}
                    />
                    {
                        this.state.erroriban ? <span className="form-input__error active">Ups, da hat sich wohl ein Fehler bei deiner IBAN eingeschlichen. Bitte überprüfe deine IBAN.</span> : null
                    }
                    <p className='text font center marginTop'>Gib bitte deine Bankverbindung (IBAN) an, damit Milka dir den Kaufpreis auf dein Konto erstatten kann.</p>
                    
                    <button type='submit' className="btn__container btn--primary btn--hover custom-file-btn">
                        <span>
                            GELD ZURÜCKERHALTEN
                        </span>
                    </button>
                  
                   
                </div>

                <p className="info-receipt">
                    {
                        t("Page.Prize.Form.Sections.Receipt", {
                            returnObjects: true,
                        }).Info
                    }
                </p>

            </div>
        );
    }

    //Form submit event
    onSubmitHandler(event) {
        event.preventDefault();
        //Validation of fields
        let validateForm = ValidateForm.validateForm('frm_receipt');
        if (!this._RECEIPT_file.files.length >= 1) {
            this.setState({ errorFile: true })
        }
        
        if (validateForm){
            this.TriggerCaptcha();
        }
        else{
            const errorField = document.querySelector(".notvalid");
            if (errorField) {
                errorField.focus();
            }
            const errorFile = document.querySelector(
                ".form-input__error.js-file-error.active"
            );
            if (errorFile) {
                errorFile.focus();
            }
        }
    }



    ProcessFormData(token) {

        this.setState({
            loaderSubmit: true
        });
    //   let validation =
        let obj = JSON.parse(sessionStorage.getItem(GLOBAL_CONFIG.Session.userinfo));
        const searchParams = new URLSearchParams(window.location.search);
        // this.setState = { cid: searchParams.get('cid') };
        // this.setState = { pid: searchParams.get('pid') };
        //controle file
      
            // fileUploaded = this._RECEIPT_file.files[0];
            let data = {
                code: this._DETAILS_code.value,
                file: this._RECEIPT_file.files[0],
                purchaseAmount: this._DETAILS_purchaseAmount.value,
                iban: this._DETAILS_iban.value,
                recaptcha: token,
                consumerId:  searchParams.get('cid'),
                participationId:  searchParams.get('pid'),
                fullname: this._DETAILS_fullname.value,
                //session storage depuis
               
            };

            // console.log('datatatat', data);
            let _data = new FormData();

            for (let key in data) {
                _data.append(key, data[key]);
            }


            CampaignServices.Receipt({ data: _data, retailer: window.PROMOTION_CAMPAIGN })
                .then((response) => {
                    console.log('response', response)
                    //final
                    if(response.data.success){
                        //loader true
                        appGoogleTracking.dataLayerPush({
                            'dataEvent': 'get_money_back',
                            'dataCategory': 'Winner Page',
                            'dataAction': 'Click on Get Money Back',
                            'dataLabel': 'EASTER_WP_PART'
                        });
                        window.location.href='/gift';
                        //this.props.history.push({ pathname: GLOBAL_CONFIG.Route.gift });
                    }
                    else{
                        this.setState({
                            loaderSubmit: false
                        });
                        let errorMess = null;
                        console.log('huhu', response.data.data.Error[0])
                        if (response.data.data.Error[0] === "INVALID_CODE"){
                            errorMess = 'UNGÜLTIGER CODE';
                            this.setState({errorcode: true})
                        }
                        else if (response.data.data.Error[0] === "ALREADY_USED"){
                            errorMess = 'SCHON BENUTZT';
                            this.setState({errorcode: true})
                        }

                        else if (response.data.data.Error[0] === "AN_ERROR_HAS_OCCURED"){
                            errorMess = 'EIN FEHLER IST AUFGETRETEN';
                        }
                        else if (response.data.data.Error[0] === "CAPTCHA_ERROR"){
                            errorMess = 'CAPTCHA FEHLER';
                        }
                        else {
                            errorMess = 'EIN FEHLER IST AUFGETRETEN';
                        }
                        // hepnbhaxnr3p
                        this.setState({
                            showPopup:true,
                            errorCodePopup:errorMess,
                        });
                        
                        const section = document.querySelector('.content-home');
                        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        // console.log(response.data.Error);
                    }
                })
                .catch((error) => {
                    console.log('error', error)
                    let { Data } = error.response.data,
                        errorStatus = Data.Error[0] || "";
                    this.ProcessError(errorStatus)
                    this._CAPTCHA.reset();
                });
    
        // let fileUploaded = null;
        // let receiptprice = 0;
        // let testfile = null;
        
        // if (this._RECEIPT_file.files.length >= 1) {
        //     fileUploaded = this._RECEIPT_file.files[0];
        // }
        //controle code
    
        //controle purchaseAmount
        
        //controle iban

        
    }

}

export default withTranslation()(PrizeAlle);